import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SigningPadComponent } from '../signing-pad/signing-pad.component';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'lib-full-screen-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, SigningPadComponent],
  template: `
  <mat-dialog-content class="h-100 w-100">
    <!-- Close button. -->
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>

    <lib-signing-pad class="h-100 w-100"
      (submitted)="base64 = $event"
      [showCloseButton]="true"
      (closed)="dialogRef.close(base64)"

    ></lib-signing-pad>
  </mat-dialog-content>

  <!-- <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions> -->
`,
  styles: [`
  // Full screen dialog.
  mat-dialog-content {
    max-height: unset !important;
    flex: 1 0 0;
    padding: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .close-button {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  }
  `]
})
export class FullScreenSignDialogComponent {

  public base64: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<FullScreenSignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { file: any }
  ) {

  }

}
